<!-- Content -->
<div>
  <site-settings-default-category-description-tab></site-settings-default-category-description-tab>
  <ng-container *ngIf="(currentUserRole$ | async)?.siteId !== null">
    <site-settings-category-description-tab
      [siteId]="(currentUserRole$ | async)?.siteId"
    ></site-settings-category-description-tab>
  </ng-container>
</div>
